export default __webpack_public_path__ + "static/media/bayc1.889361ad.jpg";